module.exports = __webpack_public_path__ + "static/media/lz_swiper_y.90080b25.jpg";